import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faYoutube,
  faSquareXTwitter,
  faSquareLinkedin,
} from "@fortawesome/free-brands-svg-icons";

export default function SocialMediaComponent({ title, showBox = true }) {
  const socialLinks = [
    {
      icon: faSquareFacebook,
      url: "https://www.facebook.com/share/1CQYcTeuU8/?mibextid=wwXIfr",
      color: "#1877F2",
      name: "Facebook",
    },
    {
      icon: faYoutube,
      url: "https://www.youtube.com/@OldBoysAssociationVCG",
      color: "#FF0000",
      name: "YouTube",
    },
    {
      icon: faSquareXTwitter,
      url: "https://twitter.com",
      color: "#000000",
      name: "Twitter",
    },
    {
      icon: faSquareLinkedin,
      url: "https://linkedin.com",
      color: "#0A66C2",
      name: "LinkedIn",
    },
  ];

  const content = (
    <>
      {title && <h6 className="fw-bold mb-3">{title}</h6>}
      <div className="d-flex justify-content-center gap-3">
        {socialLinks.map((social, index) => (
          <a
            key={index}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: social.color, transition: "transform 0.2s" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.15)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            aria-label={social.name}
          >
            <FontAwesomeIcon icon={social.icon} size="2x" />
          </a>
        ))}
      </div>
    </>
  );

  return showBox ? (
    <div
      className="rounded-3 p-3 text-center"
      style={{
        backgroundColor: "#f8f9fa",
        border: "1px solid #e9ecef",
      }}
    >
      {content}
    </div>
  ) : (
    <div className="text-center">{content}</div>
  );
}
